<template>
  <b-dropdown-item @click.prevent="downloadWithAxios(row.id, row.boarding_number)" v-if="ready">
    <i class="fa fa-lg fa-file-excel-o text-primary"></i> Export Invoice en Excel
  </b-dropdown-item>
</template>

<script>
export default {
  name: "downloadInvoiceExcel",
  props: ["row"],
  data() {
    return {
      ready: false
    };
  },
  methods: {
    forceFileDownload(response, a) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Commercial Invoice #" + a + ".xlsx"); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    downloadWithAxios(a, b) {
      this.$axios({
        method: "get",
        url: "/api/comex/shipment/" + a + "/download_invoice_excel/",
        responseType: "arraybuffer"
      })
        .then((response) => {
          this.forceFileDownload(response, b);
          this.$toast.success("Commercial Invoice generado con éxito.", "Commercial Invoice:");
        })
        .catch((error) => {
          this.$toast.error("Problemas al generar el documento", "Error:");
          console.log(error);
        });
    }
  },
  mounted() {
    this.ready = true;
  }
};
</script>

<style></style>
